<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <g id="dollar" :fill="fillColor">
      <path
        d="M12,20.75a.76.76,0,0,1-.75-.75V4a.75.75,0,0,1,1.5,0V20A.76.76,0,0,1,12,20.75Z"
      />
      <path
        d="M13.5,18.75H7a.75.75,0,0,1,0-1.5h6.5A2.54,2.54,0,0,0,16.25,15a2.54,2.54,0,0,0-2.75-2.25h-3A4,4,0,0,1,6.25,9,4,4,0,0,1,10.5,5.25H16a.75.75,0,0,1,0,1.5H10.5A2.54,2.54,0,0,0,7.75,9a2.54,2.54,0,0,0,2.75,2.25h3A4,4,0,0,1,17.75,15,4,4,0,0,1,13.5,18.75Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    fillColor: {
      type: String,
      required: false
    },
  },
};
</script>
